<h3 mat-dialog-title>
  Regenerate new API key
</h3>

<div mat-dialog-content>
  <p>Do you want to regenerate new API key?</p>
</div>

<div mat-dialog-actions>
  <button mat-button class="btn btn-light" (click)="onDelete()">Cancel</button>
  <button mat-raised-button class="btn btn-danger mx-2" (click)="onCommand()">Regenerate</button>
</div>
